import React, { Component } from "react";
import { connect } from "react-redux";
import Server from "../Server.js";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import { ProgressBar } from "primereact/progressbar";
import SignatureCanvas from "react-signature-canvas";

import Header from "../Header.js";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { DataView } from "primereact/dataview";
import { Dialog } from "primereact/dialog";
import axios from "axios";
import { Route, Link, Navigate } from "react-router-dom";
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";

class New extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();
    this.toast = React.createRef();
    this.FileUpload = this.FileUpload.bind(this);

    this.state = {
      edit: window.location.href.split("edit=")[1],
      basic: true,
      ButtonText: "ثبت درخواست",
      listViewData: [],
      Accounts: [],
      ChequeNember: 0,
      BirthDay: new Date(),
      step: 1,
      help: true,
      disableForm: false,
      ShowLoading: false,
      absoluteUrl: this.Server.getAbsoluteUrl(),
      url: this.Server.getUrl(),
      url2: this.Server.getUrl(1),
      System: this.Server.getSystem(),
    };
  }

  getAppData() {
    let that = this;
    const condition = this.state.System
      ? { condition: { code: this.state.System.code } }
      : { condition: { code: 1000 } };
    let SCallBack = function (response) {
      const appData = response.data.result[0] || {};
      that.setState({
        appData: appData,
        ShowLoading: false,
      });
    };
    let ECallBack = function (error) {};
    this.Server.send("MainApi/getAppData", condition, SCallBack, ECallBack);
  }

  ConvertNumToFarsi(text) {
    if (!text) return text;
    var id = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    return text.toString().replace(/[0-9]/g, function (w) {
      return id[+w];
    });
  }
  componentDidMount() {
    this.getAppData();
    axios
      .post(this.state.url + "checktoken", {
        token: localStorage.getItem("api_token"),
      })
      .then((response) => {
        this.setState({
          UId: response.data.authData.userId,
        });
        //this.GetAccounts();
      })
      .catch((error) => {
        //this.GetAccounts();
      });
  }
  GetAccounts(RefreshVam) {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      UId: this.state.UId,
      systemId:  this.state.System ?  this.state.System.id : null
    };
    let SCallBack = function (response) {
      that.setState({
        ShowLoading: false,
      });
    };
    let ECallBack = function (error) {
      that.setState({
        ShowLoading: false,
      });
    };

    that.setState({
      ShowLoading: true,
    });
    this.Server.send("AdminApi/GetAccountReq", param, SCallBack, ECallBack);
  }
  SetAccountReqFirst() {
    let that = this;
    if (!this.state.CodeMelli && this.state.step == 1) {
      that.toast.current.show({
        severity: "warn",
        summary: <div className="iranyekanwebmedium"></div>,
        detail: <div className="iranyekanwebmedium">کد ملی را وارد کنید</div>,
        life: 4000,
      });

      return;
    }
    if (!this.state.ShenasnameCode && this.state.step == 1) {
      that.toast.current.show({
        severity: "warn",
        summary: <div className="iranyekanwebmedium"></div>,
        detail: (
          <div className="iranyekanwebmedium">شماره شناسنامه را وارد کنید</div>
        ),
        life: 4000,
      });

      return;
    }
    if (!this.state.city && this.state.step == 1) {
      that.toast.current.show({
        severity: "warn",
        summary: <div className="iranyekanwebmedium"></div>,
        detail: (
          <div className="iranyekanwebmedium">شهر محل سکونت را وارد کنید</div>
        ),
        life: 4000,
      });

      return;
    }

    if (!this.state.fatherName && this.state.step == 1) {
      that.toast.current.show({
        severity: "warn",
        summary: <div className="iranyekanwebmedium"></div>,
        detail: <div className="iranyekanwebmedium">نام پدر را وارد کنید</div>,
        life: 4000,
      });

      return;
    }
    if (!this.state.mobile && this.state.step == 1) {
      that.toast.current.show({
        severity: "warn",
        summary: <div className="iranyekanwebmedium"></div>,
        detail: (
          <div>
            <div className="iranyekanwebmedium">موبایل را وارد کنید</div>
          </div>
        ),
        life: 4000,
      });

      return;
    }
    if (!this.state.name && this.state.step == 1) {
      that.toast.current.show({
        severity: "warn",
        summary: <div className="iranyekanwebmedium"></div>,
        detail: <div className="iranyekanwebmedium">نام را وارد کنید</div>,
        life: 4000,
      });

      return;
    }
    if (!this.state.address && this.state.step == 1) {
      that.toast.current.show({
        severity: "warn",
        summary: <div className="iranyekanwebmedium"></div>,
        detail: <div className="iranyekanwebmedium">آدرس را وارد کنید</div>,
        life: 4000,
      });

      return;
    }
    if (!this.state.BirthDay && this.state.step == 1) {
      that.toast.current.show({
        severity: "warn",
        summary: <div className="iranyekanwebmedium"></div>,
        detail: (
          <div className="iranyekanwebmedium">تاریخ تولد را وارد کنید</div>
        ),
        life: 4000,
      });

      return;
    }
    if (!this.state.phone && this.state.step == 1) {
      that.toast.current.show({
        severity: "warn",
        summary: <div className="iranyekanwebmedium"></div>,
        detail: (
          <div className="iranyekanwebmedium">تلفن ثابت را وارد کنید</div>
        ),
        life: 4000,
      });

      return;
    }

    this.setState({
      step: 2,
    });
  }
  SetAccountReqTwo() {
    let that = this;

    if (!this.state.Authentication_Pic && this.state.step == 2) {
      that.toast.current.show({
        severity: "warn",
        summary: <div className="iranyekanwebmedium"></div>,
        detail: (
          <div className="iranyekanwebmedium">
            تصویر اهراز هویت را آپلود کنید
          </div>
        ),
        life: 4000,
      });

      return;
    }
    if (!this.state.CartMelli_Pic && this.state.step == 2) {
      that.toast.current.show({
        severity: "warn",
        summary: <div className="iranyekanwebmedium"></div>,
        detail: (
          <div className="iranyekanwebmedium">
            {" "}
            تصویر کارت ملی را آپلود کنید
          </div>
        ),
        life: 4000,
      });

      return;
    }
    if (this.sigPad.toData().length == 0 && this.state.step == 2) {
      that.toast.current.show({
        severity: "warn",
        summary: (
          <div className="iranyekanwebmedium">خطا در برقراری ارتباط</div>
        ),
        detail: (
          <div className="iranyekanwebmedium">نمونه امضا را وارد کنید</div>
        ),
        life: 4000,
      });

      return;
    }
    let sign = this.sigPad.getTrimmedCanvas().toDataURL("image/png");
    that.setState({
      loading: 1,
      disableForm: true,
    });
    let param = {
      token: localStorage.getItem("api_token"),
      CodeMelli: this.state.CodeMelli,
      city: this.state.city,
      job: this.state.job,
      jobCity: this.state.jobCity,
      cityOfBirth: this.state.cityOfBirth,
      codePosti: this.state.codePosti,
      ShenasnameCode: this.state.ShenasnameCode,
      fatherName: this.state.fatherName,
      mobile: this.state.mobile,
      address: this.state.address,
      phone: this.state.phone,
      BirthDay:
        this.state.BirthDay && this.state.BirthDay.year
          ? `${this.state.BirthDay.year}/${this.state.BirthDay.month}/${this.state.BirthDay.day}`
          : null,
      name: this.state.name,
      CartMelli_Pic: this.state.CartMelli_Pic,
      Authentication_Pic: this.state.Authentication_Pic,
      sign: sign,
      UId: this.state.UId,
      systemId:  this.state.System ?  this.state.System.id : null
    };
    let SCallBack = function (response) {
      that.setState({
        loading: 0,
      });
      if (response.data.err) {
        that.toast.current.show({
          severity: "error",
          summary: <div className="iranyekanwebmedium"></div>,
          detail: <div className="iranyekanwebmedium">{response.data.err}</div>,
          life: 4000,
        });
        that.setState({
          loading: 0,
          disableForm: false,
        });
        return;
      }

      that.toast.current.show({
        severity: "success",
        summary: <div className="iranyekanwebmedium"></div>,
        detail: (
          <div className="iranyekanwebmedium">عملیات با موفقیت انجام شد</div>
        ),
        life: 4000,
      });
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
        disableForm: false,
      });
      that.toast.current.show({
        severity: "error",
        summary: <div className="iranyekanwebmedium"></div>,
        detail: <div className="iranyekanwebmedium">عملیات انجام نشد</div>,
        life: 4000,
      });

      console.log(error);
    };
    this.Server.send("AdminApi/SetAccountReq", param, SCallBack, ECallBack);
  }

  FileUpload(e) {
    e.preventDefault();
    const formData = new FormData();
    let name = e.target.name;
    formData.append("myImage", e.target.files[0]);
    formData.append("ExtraFile", 1);
    formData.append("createAcc", 1);

    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        let percent = parseInt((loaded * 100) / total);
        this.setState({
          showLoadedCount: 1,
          disableForm: true,
          loadedCount: percent,
        });
        if (percent == "100") {
          this.setState({
            disableForm: false,
            showLoadedCount: 0,
          });
        }
      },
    };
    axios({
      url: `${this.state.url2}uploadFile`,
      data: formData,
      method: "post",
      config,
    })
      .then((response) => {
        this.setState({
          help: false,
          [name]: this.state.absoluteUrl + response.data.split("public")[1],
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  render() {
    return !this.state.ShowLoading ? (
      <div>
        {this.state.appData && (
          <Header
            ComponentName="درخواست افتتاح حساب"
            appDataParam={this.state.appData}
          />
        )}
        <Toast
          ref={this.toast}
          position="top-right"
          style={{ fontFamily: "iranyekanwebmedium", textAlign: "right" }}
        />
        <div
          style={{
            display: "flex",
            height: "100%",
            justifyContent: "space-between",
            flexDirection: "column",
            padding: 8,
          }}
        >
          {this.state.showLoadedCount > 0 && (
            <ProgressBar value={this.state.loadedCount} />
          )}
          {this.state.step == 2 && (
            <div style={{ textAlign: "right", marginTop: 15 }}>
              <Button
                className="p-button-info iranyekanwebmedium"
                onClick={() => this.setState({ step: 1 })}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <i className="fas fa-forward" />
                </div>
              </Button>
            </div>
          )}
          <div>
            <p
              style={{
                fontFamily: "iranyekanwebmedium",
                textAlign: "center",
                fontSize: 13,
              }}
            >
              برای افتتاح حساب موارد زیر را به طور کامل تکمیل نمایید
            </p>
            {this.state.step == 2 && (
              <p
                style={{
                  fontFamily: "iranyekanwebmedium",
                  textAlign: "center",
                  fontSize: 13,
                }}
              >
                وضعیت افتتاح حساب شمااز طریق پیامک ارسال خواهد شد
              </p>
            )}
          </div>

          {this.state.step == 1 && (
            <div style={{ textAlign: "right", marginTop: 15 }}>
              <label
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                  fontSize: 13,
                }}
              >
                نام و نام خانوادگی
              </label>

              <InputText
                autocomplete="off"
                disabled={this.state.disableForm}
                value={this.state.name}
                keyboardType="default"
                placeholder=""
                name="name"
                onChange={(text) => {
                  this.setState({
                    name: text.target.value,
                  });
                }}
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                }}
              />
            </div>
          )}
          {this.state.step == 1 && (
            <div style={{ textAlign: "right" }}>
              <label
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                  fontSize: 13,
                }}
              >
                کد ملی
              </label>
              <InputText
                autocomplete="off"
                disabled={this.state.disableForm}
                value={this.state.CodeMelli}
                keyboardType="default"
                name="CodeMelli"
                onChange={(text) => {
                  this.setState({
                    CodeMelli: text.target.value,
                  });
                }}
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                }}
              />
            </div>
          )}
          {this.state.step == 1 && (
            <div style={{ textAlign: "right" }}>
              <label
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                  fontSize: 13,
                }}
              >
                شماره شناسنامه
              </label>
              <InputText
                autocomplete="off"
                disabled={this.state.disableForm}
                value={this.state.ShenasnameCode}
                keyboardType="default"
                name="ShenasnameCode"
                onChange={(text) => {
                  this.setState({
                    ShenasnameCode: text.target.value,
                  });
                }}
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                }}
              />
            </div>
          )}
          {this.state.step == 1 && (
            <div style={{ textAlign: "right" }}>
              <label
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                  fontSize: 13,
                }}
              >
                نام پدر
              </label>
              <InputText
                autocomplete="off"
                disabled={this.state.disableForm}
                value={this.state.fatherName}
                keyboardType="default"
                name="fatherName"
                onChange={(text) => {
                  this.setState({
                    fatherName: text.target.value,
                  });
                }}
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                }}
              />
            </div>
          )}
          {this.state.step == 1 && (
            <div style={{ textAlign: "right" }}>
              <label
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                  fontSize: 13,
                }}
              >
                شغل
              </label>
              <InputText
                autocomplete="off"
                disabled={this.state.disableForm}
                value={this.state.job}
                keyboardType="default"
                name="job"
                onChange={(text) => {
                  this.setState({
                    job: text.target.value,
                  });
                }}
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                }}
              />
            </div>
          )}

          {this.state.step == 1 && (
            <div style={{ textAlign: "right", marginTop: 15 }}>
              <label
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                  fontSize: 13,
                }}
              >
                تلفن همراه
              </label>

              <InputText
                autocomplete="off"
                disabled={this.state.disableForm}
                value={this.state.mobile}
                keyboardType="default"
                placeholder=""
                name="mobile"
                onChange={(text) => {
                  this.setState({
                    mobile: text.target.value,
                  });
                }}
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                }}
              />
            </div>
          )}
          {this.state.step == 1 && (
            <div style={{ textAlign: "right", marginTop: 15 }}>
              <label
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                  fontSize: 13,
                }}
              >
                تلفن ثابت
              </label>

              <InputText
                autocomplete="off"
                disabled={this.state.disableForm}
                value={this.state.phone}
                keyboardType="default"
                placeholder=""
                name="phone"
                onChange={(text) => {
                  this.setState({
                    phone: text.target.value,
                  });
                }}
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                }}
              />
            </div>
          )}

          {this.state.step == 1 && (
            <div
              style={{
                textAlign: "right",
                marginTop: 15,
                width: "100%",
                display: "flex",
                flexDirection: "column",
              }}
              className="DatePicker"
            >
              <label
                style={{
                  textAlign: "right",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                  fontSize: 13,
                }}
              >
                تاریخ تولد
              </label>
              <DatePicker
                date={this.state.BirthDay}
                disabled={this.state.disableForm}
                format={"DD-MM-YYYY"}
                onChange={(value) => {
                  this.setState({ BirthDay: value });
                }}
                locale="fa"
                formatInputText={() => {
                  if (!this.state.BirthDay.day) return "";
                  return ` ${this.state.BirthDay.day} / ${this.state.BirthDay.month} / ${this.state.BirthDay.year} `;
                }}
              />
            </div>
          )}
          {this.state.step == 1 && (
            <div style={{ textAlign: "right" }}>
              <label
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                  fontSize: 13,
                }}
              >
                شهر محل تولد
              </label>
              <InputText
                autocomplete="off"
                disabled={this.state.disableForm}
                value={this.state.cityOfBirth}
                keyboardType="default"
                name="cityOfBirth"
                onChange={(text) => {
                  this.setState({
                    cityOfBirth: text.target.value,
                  });
                }}
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                }}
              />
            </div>
          )}
          {this.state.step == 1 && (
            <div style={{ textAlign: "right" }}>
              <label
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                  fontSize: 13,
                }}
              >
                شهر محل کار
              </label>
              <InputText
                autocomplete="off"
                disabled={this.state.disableForm}
                value={this.state.jobCity}
                keyboardType="default"
                name="jobCity"
                onChange={(text) => {
                  this.setState({
                    jobCity: text.target.value,
                  });
                }}
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                }}
              />
            </div>
          )}
          {this.state.step == 1 && (
            <div style={{ textAlign: "right" }}>
              <label
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                  fontSize: 13,
                }}
              >
                شهر محل سکونت
              </label>
              <InputText
                autocomplete="off"
                disabled={this.state.disableForm}
                value={this.state.city}
                keyboardType="default"
                name="city"
                onChange={(text) => {
                  this.setState({
                    city: text.target.value,
                  });
                }}
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                }}
              />
            </div>
          )}

          {this.state.step == 1 && (
            <div style={{ textAlign: "right" }}>
              <label
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                  fontSize: 13,
                }}
              >
                کد پستی
              </label>
              <InputText
                autocomplete="off"
                disabled={this.state.disableForm}
                value={this.state.codePosti}
                keyboardType="default"
                name="codePosti"
                onChange={(text) => {
                  this.setState({
                    codePosti: text.target.value,
                  });
                }}
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                }}
              />
            </div>
          )}
          {this.state.step == 1 && (
            <div style={{ textAlign: "right", marginTop: 15 }}>
              <label
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                  fontSize: 13,
                }}
              >
                آدرس
              </label>

              <InputText
                autocomplete="off"
                disabled={this.state.disableForm}
                value={this.state.address}
                keyboardType="default"
                placeholder=""
                name="address"
                onChange={(text) => {
                  this.setState({
                    address: text.target.value,
                  });
                }}
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                }}
              />
            </div>
          )}
          {this.state.step == 2 && (
            <div style={{ textAlign: "right", marginTop: 15 }}>
              <label
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                  fontSize: 13,
                }}
              >
                آپلود تصویر کارت ملی
              </label>
              <InputText
                autocomplete="off"
                disabled={this.state.disableForm}
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                }}
                className="form-control IRANYekan"
                keyboardType="default"
                placeholder=""
                autoComplete="off"
                onChange={this.FileUpload}
                type="file"
                id="CartMelli_Pic"
                name="CartMelli_Pic"
              />
            </div>
          )}
          {this.state.step == 2 && this.state.CartMelli_Pic && (
            <div style={{ textAlign: "right", marginTop: 15 }}>
              <img src={this.state.CartMelli_Pic} style={{ width: 200 }} />
            </div>
          )}
          {this.state.step == 2 && (
            <div style={{ textAlign: "right", marginTop: 15 }}>
              <label
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                  fontSize: 13,
                }}
              >
                آپلود تصویر اهراز هویت
              </label>
              <InputText
                autocomplete="off"
                disabled={this.state.disableForm}
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                }}
                className="form-control IRANYekan"
                keyboardType="default"
                placeholder=""
                autoComplete="off"
                onChange={this.FileUpload}
                type="file"
                id="Authentication_Pic"
                name="Authentication_Pic"
              />
            </div>
          )}
          {this.state.step == 2 && this.state.Authentication_Pic && (
            <div style={{ textAlign: "right", marginTop: 15 }}>
              <img src={this.state.Authentication_Pic} style={{ width: 200 }} />
            </div>
          )}
          {this.state.step == 2 && (
            <label
              onClick={() => {
                this.setState({ help: !this.state.help });
              }}
              style={{
                textAlign: "right",
                marginBottom: 8,
                fontFamily: "iranyekanwebmedium",
                width: "100%",
                fontSize: 13,
                backgroundColor: "#9f814c",
                padding: 10,
                marginTop: 10,
                color: "#fff",
                display: "flex",
                justifyContent: "space-around",
              }}
            >
              <span>راهنمای آماده سازی تصویر اهراز هویت</span>
              <i
                className="far fa-question-circle"
                style={{ fontSize: 20 }}
              ></i>{" "}
            </label>
          )}
          {this.state.step == 2 && this.state.help && (
            <div style={{ textAlign: "center" }}>
              <div
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                  fontSize: 13,
                  marginBottom: 8,
                }}
              >
                تصویر اهراز هویت باید مطابق نمونه زیر به صورت سلفی و واضح گرفته
                شود
              </div>
              <div
                style={{
                  textAlign: "center",
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                  fontSize: 13,
                  marginBottom: 8,
                }}
              >
                دقت کنید اطلاعات کارت ملی در تصویر خوانا باشد
              </div>
              <img
                src="https://ansar724.com/ehrazhoviyat.jpg"
                style={{ width: "90%" }}
              />
            </div>
          )}

          {this.state.step == 2 && (
            <div
              floatingLabel
              style={{
                marginTop: 15,
                border: "1px solid #ccc",
                position: "relative",
                padding: 5,
                textAlign: "right",
              }}
            >
              <div className="iranyekanwebmedium" style={{ fontSize: 13 }}>
                نمونه امضا
              </div>
              <SignatureCanvas
                penColor="green"
                canvasProps={{
                  width: 500,
                  height: 200,
                  className: "sigCanvas",
                }}
                ref={(ref) => {
                  this.sigPad = ref;
                }}
              />
              <Button
                block
                info
                rounded
                style={{
                  marginTop: 10,
                  marginLeft: 10,
                  marginRight: 10,
                  marginBottom: 10,
                  position: "absolute",
                  top: 0,
                  left: 0,
                }}
                onClick={() => {
                  this.sigPad.clear();
                }}
              >
                <span
                  style={{ fontFamily: "iranyekanwebmedium", fontSize: 15 }}
                >
                  پاک کردن
                </span>
              </Button>
            </div>
          )}

          <div style={{ textAlign: "center" }}>
            {this.state.step == 1 ? (
              <Button
                disabled={this.state.disableForm}
                className="p-button-secondary iranyekanwebmedium"
                style={{ marginTop: 50, padding: 12 }}
              >
                <span
                  className="iranyekanwebmedium"
                  style={{
                    width: "100%",
                    fontSize: 17,
                    fontFamily: "iranyekanwebmedium",
                  }}
                  onClick={() => this.SetAccountReqFirst()}
                >
                  ادامه درخواست
                </span>
              </Button>
            ) : (
              <Button
                disabled={this.state.disableForm}
                className="p-button-success iranyekanwebmedium"
                style={{ marginTop: 50, padding: 12 }}
              >
                <span
                  className="iranyekanwebmedium"
                  style={{
                    width: "100%",
                    fontSize: 17,
                    fontFamily: "iranyekanwebmedium",
                  }}
                  onClick={() => this.SetAccountReqTwo()}
                >
                  ثبت درخواست
                </span>
              </Button>
            )}
          </div>
        </div>
      </div>
    ) : (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <ProgressSpinner
          style={{ width: "50px", height: "50px" }}
          strokeWidth="2"
          fill="var(--surface-ground)"
          animationDuration=".5s"
        />
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    username: state.username,
    password: state.password,
    ip: state.ip,
    account: state.account,
    place: state.place,
    fullname: state.fullname,
    tokenrb: state.tokenrb,
    mobile: state.mobile,
    appData: state.appData,
    creditPrice: state.creditPrice,
    systemId: state.systemId,
  };
}
export default connect(mapStateToProps)(New);
